import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import PlanUpthere from './PlanUpthere.vue'
registerVueComponentAndAngularBindings('plan:upthere', 'planUpthere', PlanUpthere);


import PlanUpthereTimetravel from './PlanUpthereTimetravel.vue'
registerVueComponentAndAngularBindings('plan_timetravel:upthere', 'planUpthereTimetravel', PlanUpthereTimetravel);